import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cn from 'classnames';
import get from 'lodash/get';

import { useSubscriberControls } from '../../utils/useSubscriberControls';
import { ConnectionShape } from '../../../../redux/opentok/helpers/shapes';
import SimpleAvatar from '../../../common/SimpleAvatar';
import Icon from '../../../Icon';
import styles from './styles.styl';
import { formatName } from '../../../../redux/opentok/helpers/utils';

function UserRow({
  connection: { entity, id, user } = {},
  intl: { formatMessage },
  isProvider,
  pinnedId,
  onPin,
  isMe,
}) {
  const userName = formatName(user, isMe, formatMessage);
  const avatar = get(user, 'avatar.thumbMin');
  const pinned = pinnedId === id;
  const {
    handleVideoToggle,
    handleAudioToggle,
    handlePinToggle,
    audioIcon,
    videoIcon,
    pinIcon,
  } = useSubscriberControls({ pinned, onPin, id, entity });

  return (
    <div className={styles.userRow}>
      <div className={styles.userLeft}>
        <SimpleAvatar src={avatar} size={48} text={userName} bordered />
        <span className={cn(styles.userName, { [styles.isMe]: isMe })}>
          {userName}
        </span>
      </div>
      {!isMe && (
        <div className={styles.userActions}>
          {isProvider && (
            <Fragment>
              <button onClick={handleAudioToggle} type="button">
                <Icon name={audioIcon} size={16} />
              </button>
              <button onClick={handleVideoToggle} type="button">
                <Icon name={videoIcon} size={16} />
              </button>
            </Fragment>
          )}
          <button onClick={handlePinToggle} type="button">
            <Icon name={pinIcon} size={16} />
          </button>
        </div>
      )}
    </div>
  );
}

UserRow.propTypes = {
  isMe: PropTypes.bool,
  isProvider: PropTypes.bool,
  connection: ConnectionShape,
  onPin: PropTypes.func,
  pinnedId: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(UserRow);



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/MobileVideo/MobileSidebar/UserRow.jsx